import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export interface UseParamsProps
{
    onLoaded: (p: any) => void
}

export function UseParams(props: UseParamsProps) 
{
    let p = useParams();

    useEffect(() =>
    {
        props.onLoaded(p);
    }, [p]);
    return <></>;
}